export function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function clampSliderIndex(
  value,
  length,
) {
  if (!length) {
    return 0;
  }

  return (
    ((value % length) + length) %
    length
  );
}

export function scrollToTournamentSection(
  sectionId,
  offset = 110,
) {
  const element =
    document.getElementById(
      sectionId,
    );

  if (!element) {
    return;
  }

  const top =
    element.getBoundingClientRect()
      .top +
    window.pageYOffset -
    offset;

  window.scrollTo({
    top,
    behavior: "smooth",
  });
}

export function openExternalPage(url) {
  if (!url) {
    return;
  }

  window.open(
    url,
    "_blank",
    "noopener,noreferrer",
  );
}